import { useEffect } from "react";
import CartProducts from "@components/features/customer/CartProducts";
import CartViewNavigate from "@components/features/navigation/CartViewNavigate";
import withAuth from "@components/layouts/auth/WithAuth";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "@stores/slices/userSlice";
import { isWebview, clickCartButtonNative } from "@utils/webview.util";

const CartProductsPage = () => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  useEffect(() => {
    if (isWebview() && isAuthenticated) {
      clickCartButtonNative();
    }
  }, [isAuthenticated]);

  return (
    <>
      <CartProducts />
      <CartViewNavigate />
    </>
  );
};

export default withAuth(CartProductsPage);
